import DefaultCatalogConfig, { CatalogConfigProps } from './DefaultCatalogConfig';

export default class ItemCategoryRecommendationsConfig extends DefaultCatalogConfig {
  constructor(props: CatalogConfigProps) {
    super(props);
    this.item.approve = true;
    this.item.reject = true;
    this.allowHoverActions = true;

    this.canPaste = () => false;

    this.indentTree = false;
  }
}
